import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';

import '../addressProcess/addressProcess.scss';
import TableLoader from '../addressProcess/loader/table-loader';
import { DI_VPN_HEADERS, PRE_ORDER_DI_VPN_HEADERS, PRE_ORDER_UPGRADE_DI_VPN_HEADERS, NLD_HEADERS, BULK_UPGRADE_PNQ_HEADER, paginationLength } from './table/custom-table.constant';
import MainHeader from './main-header/main-header';
import NeedAssistantPopup from '../need-assistant/need-assistant-popup';
import LocationModal from './location-modal/loacation-modal';
import { ConfigureSiteWithExcel } from './file-modal/file-modal';
import {
  convertToLocationData,
  convertToTableContent,
  SEARCH_OPTIONS,
  CUSTOMER_MESSAGE,
  TOAST_TYPE,
  isUserTypeIsKAM,
  KAM_MESSAGE,
  getInfoContent,
  IS_MULTIPLE_SORT,
  EDIT_CART_ACTION,
  getBulkEditRequest
} from './configure-plan-pricing-constant';
import { Footer } from './footer/footer';
import ViewAvailableConfiguration from './view-available-configuration-modal/view-available-configuration-modal';
import { getCommercialAttributesList, submitNeedAssistance } from 'common/helper/api.helper';
import { findParamFromUrl, getFromSessionStorage, scrollToTop, setInSessionStorage, isNull, handleError } from 'common/utils/app.utils';
import { DEDICATED_COMMON_PARAMS, isNLD_OR_LL, USER_TYPE, isBulkUpgrade, isVPN_OR_DI, isLoiAvailable, isPreOrder, isBulkPreOrderUpgrade } from 'common/constants/app.constants';
import { KamView } from './kamView';
import { CART_ID, MULTI_SITE_MODULE_ID, DEFAULT_TOAST_MSG, ERROR_TOAST, CART_STATUS } from 'home/view/manage-feasibility/constants';
import ribbonBadge from '../images/ribbon-badge.svg';
import { AppContext } from 'App';
import { doBulkEditAction, fetchLineItems, sendQuotation } from './configure-plan-pricing.service';
import { fetchRateCardIdList, getLead, upgradeFetchCircuitDetails } from 'home/view/manage-feasibility/services';
import CancelOrderPopup from '../cancelOrderPopup/cancelOrderPopup';
import './configure-plan-pricing.scss';
import { BulkActions } from './bulkEditActions/BulkAction';
import { EmailPricingProposal } from 'common/components/email-pricing-proposal/email-pricing-proposal.component';
import CircuitDetail from 'home/view/manage-feasibility/components/organisms/CircuitDetail/CircuitDetail';
import { LEAD_STATUS, MODULE_ID, PNQ_AUTHORIZATION_HEADER } from 'home/common/constants/constants';

import { CustomTable } from 'common/components/table/table';
import CustomSearchFilter from './search-filter/search-filter-wrapper';
import { CELLTYPE_ENUM, DEFAULT_SORT_MODEL, prepareSortModel, SHOWROWS_ENUM } from 'common/components/table/table.constant';
import { getKamDetailsNotification } from 'home/view/check-feasibility/comp-generator/component.generator';

const partyId = findParamFromUrl('partyId', false) || '2285375';

const ConfigurePlanPricing = (props) => {
  const getTableHeaders = () => {
    if (isNLD_OR_LL()) {
      return NLD_HEADERS;
    }

    if (isBulkUpgrade()) {
      if (isBulkPreOrderUpgrade()) {
        return PRE_ORDER_UPGRADE_DI_VPN_HEADERS;
      }

      return BULK_UPGRADE_PNQ_HEADER;
    }

    if (isPreOrder()) {
      return PRE_ORDER_DI_VPN_HEADERS;
    }

    return DI_VPN_HEADERS;
  };

  const HEADERS = getTableHeaders();
  const { isdedicatedJourney, history } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [showAvailableConfig, setShowAvailableConfig] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showEmailPopUp, setShowEmailPopUp] = useState(false);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [showNeedAssistancePopUp, setNeedAssistancePopUp] = useState(false);
  const [blockJourney, SetBlockJourney] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [remarksValue, setRemarksValue] = useState('');
  let [commercialAttribute, setCommercialAttributes] = useState({});
  const [reFetch, setReFetch] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [displayOneTime, setDisplayOneTime] = useState(true);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [infoContent, setInfoContent] = useState('');
  const [customerDetail, setCustomerDetail] = useState({});

  const [lineItems, setLineItems] = useState({});
  const [showCancelCart, setShowCancelCart] = useState(false);
  const [tableHeaders, setTableHeaders] = useState(HEADERS);

  const [circuitModalDataSet, setCircuitModalData] = useState({});
  const [showCircuitDetailModal, setShowCircuitDetailModal] = useState(false);

  const { setActiveStep, setToast, showSteps } = useContext(AppContext);
  const [isSameMedia, setIsSameMedia] = useState(false);
  const [rateCardIdList, setRateCardIdList] = useState([]);
  const [selectedRateCardId, setSelectedRateCardId] = useState({});

  const requestParams = useRef({});

  const cartId = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID);

  const onViewAvailableConfiguration = () => {
    setShowAvailableConfig(!showAvailableConfig);
  };

  const onEmailPricing = () => {
    setShowEmailPopUp(!showEmailPopUp);
  };

  const onNeedAssistance = () => {
    setNeedAssistancePopUp(!showNeedAssistancePopUp);
  };

  const onConfigSiteWithExcel = () => {
    setShowFileUpload(true);
  };

  const onEmailPricingSubmit = (email) => {
    setIsLoading(true);
    const request = { cartId, email };
    sendQuotation(request).then(
      ({ data: { result } }) => {
        setToast(true, `${CUSTOMER_MESSAGE.EMAIl_PRICING} ${email}`, TOAST_TYPE.SUCCESS);
        setIsLoading(false);
        setShowEmailPopUp(false);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
        setShowEmailPopUp(false);
      }
    );
  };

  const closeEmail = () => {
    setShowEmailPopUp(false);
  };

  const onCellClickHandler = ({ rowData, headerConfig }) => {
    if (headerConfig?.key === 'lineItemId') {
      setSelectedRowData({ ...rowData, lineItems });

      if (isBulkUpgrade() && !isBulkPreOrderUpgrade()) {
        renderCircuitDetailModal(rowData.lineItemId);
      } else {
        setShowLocationModal((prevState) => !prevState);
      }
    } else {
      rowData.checkBox = { ...rowData?.checkBox, isChecked: true };
    }
  };

  const renderCircuitDetailModal = async (circuitId) => {
    try {
      const { res, err } = await upgradeFetchCircuitDetails(circuitId);

      if (res) {
        const { data: { success = false, result = {} } = {} } = res;
        if (success) {
          setCircuitModalData(result);
          setShowCircuitDetailModal(true);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

      setToast(true, errorMsg, ERROR_TOAST);
      throw new Error(errorMsg);
    }
  };

  const onSaveNeedAssitance = (closeNeedAssistant) => {
    let payLoad = {};
    payLoad['remarks'] = remarksValue;
    payLoad['cartId'] = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID);
    submitNeedAssistance(payLoad, true)
      .then((response) => {
        closeNeedAssistant && closeNeedAssistant();
        let data = response && response.data && response.data.result;
        SetBlockJourney(!blockJourney);
        setToast(true, getKamDetailsNotification(customerDetail?.kamDetails), TOAST_TYPE.WARNING);
        setInSessionStorage(MULTI_SITE_MODULE_ID, CART_STATUS, data?.cartStatus);
      })
      .catch((err) => {
        console.log(err);
        closeNeedAssistant && closeNeedAssistant();
        // To be removed
        // setToast(true, CUSTOMER_MESSAGE.NEED_ASSISTANCE, TOAST_TYPE.SUCCESS);
      });
  };

  const fetchLeadAsync = (updatedRateCardIdList) => {
    setIsLoading(true);
    getLead(isUserTypeIsKAM())
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.success && res?.data?.result) {
          const selectedRateCardId = updatedRateCardIdList?.find((item) => item.rfp_num === res?.data?.result?.rateCardId) || updatedRateCardIdList?.[0];
          setSelectedRateCardId(selectedRateCardId);
          // handleRateCardIdChange(selectedRateCardId);
        }
      })
      .catch((err) => {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setIsLoading(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      });
  };

  const fetchRateCardIdListAsync = () => {
    setIsLoading(true);

    fetchRateCardIdList()
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.success && res?.data?.result?.rateCardIdList) {
          const updatedRateCardIdList = res.data.result.rateCardIdList.map((item) => {
            item['key'] = item.rfp_num;
            item['displayName'] = item.rfp_num;

            return item;
          });

          setRateCardIdList(updatedRateCardIdList);
          fetchLeadAsync(updatedRateCardIdList);
        }
      })
      .catch((err) => {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setIsLoading(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      });
  };

  const callFetchLineItems = (sortModel = DEFAULT_SORT_MODEL, page = 1, size = SHOWROWS_ENUM.defaultValue, searchModel = {}) => {
    const pnqToken = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);

    if (isUserTypeIsKAM() && isNull(pnqToken)) {
      return false;
    }

    setIsLoading(true);
    let params = {
      page: page - 1,
      size,
      cartId: cartId,
      ...sortModel,
      ...searchModel
    };
    fetchLineItems(params).then(
      ({ data: { result } }) => {
        let mediaType = {};
        const convertedLineItems = { ...result, content: convertToTableContent(result?.content, mediaType, isSameMedia) };
        setLineItems(convertedLineItems);

        // handle rate card multi-site
        if (!isUserTypeIsKAM() && !isBulkUpgrade()) {
          fetchRateCardIdListAsync();
        }

        // set company agreed rate text if any line item has standardRate === false
        const nonStandardRateLineItems = convertedLineItems?.content?.filter((item) => item?.rawContent?.planDetail?.standardRate === false);

        if (nonStandardRateLineItems?.length) {
          setInfoContent(getInfoContent());
        } else {
          setInfoContent('');
        }

        setIsLoading(false);
        const { message, type } = {
          message: CUSTOMER_MESSAGE.INFO,
          type: TOAST_TYPE.SUCCESS
        };
        if (displayOneTime && !isUserTypeIsKAM()) {
          const savedCartStatus = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_STATUS);
          if (isBulkUpgrade() && !isBulkPreOrderUpgrade()) {
            if (savedCartStatus === LEAD_STATUS.PNQ_IN_PROGRESS) {
              setToast(true, CUSTOMER_MESSAGE.NEED_ASSISTANCE, type);
            } else if (savedCartStatus === LEAD_STATUS.PNQ_COMPLETED) {
              setToast(true, CUSTOMER_MESSAGE.PRICE_UPDATED_TOAST, type);
            } else {
              setToast(true, message, type);
            }
          } else if (!isLoiAvailable()) {
            if (savedCartStatus === LEAD_STATUS.SEND_TO_DOA) {
              setToast(true, CUSTOMER_MESSAGE.PRE_ORDER_DOA_INFO, TOAST_TYPE.WARNING);
            } else if (savedCartStatus === LEAD_STATUS.PRICING_DOA_APPROVED) {
              setToast(true, CUSTOMER_MESSAGE.PRE_ORDER_PRICE_UPDATED_TOAST, type);
            } else {
              setToast(true, message, type);
            }
          } else {
            setToast(true, message, type);
          }
        }
        setDisplayOneTime(false);
      },
      (err) => {
        // console.log(err);
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setIsLoading(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
        //setIsLoading(false); // to be removed
      }
    );

    requestParams.current = params;
  };

  const fetchCommercialAttributes = () => {
    let payload = {};
    payload.configFields = 'COMMERCIAL_ATTRIBUTE';
    payload.productType = DEDICATED_COMMON_PARAMS.serviceType;
    getCommercialAttributesList(payload)
      .then((response) => {
        let responseData = response && response.data && response.data.result && response.data.result.commercialAttributes;
        setCommercialAttributes(responseData);
      })
      .catch((err) => {});
  };

  const onTableStateChange = ({ sort, currentPage, showRows, searchModel, activeColumn }) => {
    callFetchLineItems(prepareSortModel(sort, activeColumn, IS_MULTIPLE_SORT), currentPage, showRows, searchModel);
  };

  const renderMessage = (message) => {
    if (message.text) {
      return (
        <div class={`tooltip_wrap ${message.type}`}>
          {message.type === 'error' ? <span>* </span> : <span class="material-icons-outlined">info</span>}

          {message.text}
        </div>
      );
    }
  };

  const handleRateCardIdChange = (selectedRateCard) => {
    setIsLoading(true);
    setSelectedRateCardId(selectedRateCard);
    const requestParam = getBulkEditRequest(EDIT_CART_ACTION.UPDATE_RATE_CARD, [], selectedRateCard?.key);
    doBulkEditAction(requestParam)
      .then((res) => {
        setIsLoading(false);
        reFetchRecords();
      })
      .catch((err) => {
        setIsLoading(false);
        handleError(err);
      });
  };

  const renderHeaderSection = (hide) => {
    return (
      <React.Fragment>
        {!hide && (
          <React.Fragment>
            <div className="table_header">
              <div className="inside_header">
                <MainHeader
                  orderId={cartId}
                  feasibileSite={(lineItems.feasibilityStatusMap && lineItems.feasibilityStatusMap.FEASIBLE) || lineItems.totalElement}
                  onViewAvailableConfiguration={onViewAvailableConfiguration}
                  onEmailPricing={onEmailPricing}
                  onNeedAssistance={onNeedAssistance}
                  blockJourney={blockJourney}
                  onConfigSiteWithExcel={onConfigSiteWithExcel}
                  finalPrice={customerDetail && customerDetail.finalPrice}
                  isSameMedia={isSameMedia}
                  rateCardIdList={rateCardIdList}
                  selectedRateCardId={selectedRateCardId}
                  handleRateCardIdChange={handleRateCardIdChange}
                ></MainHeader>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  const reFetchRecords = () => {
    callFetchLineItems({ ...requestParams.current });
    setReFetch(!reFetch);
  };

  const renderSelectAll = () => {
    if (isBulkUpgrade()) {
      return null;
    }

    if (isSameMedia && !isUserTypeIsKAM()) {
      return <BulkActions records={lineItems} updateRecords={setLineItems} reFetchRecords={reFetchRecords} onConfigSiteWithExcel={onConfigSiteWithExcel} />;
    } else if (!(blockJourney || isUserTypeIsKAM())) {
      return <BulkActions records={lineItems} updateRecords={setLineItems} reFetchRecords={reFetchRecords} onConfigSiteWithExcel={onConfigSiteWithExcel} />;
    }
  };

  const onExcelFileUploaded = (fileName) => {
    callFetchLineItems();
    const message = isUserTypeIsKAM() ? KAM_MESSAGE.SITE_FILE_UPDATED_SUCCESS : CUSTOMER_MESSAGE.SITE_FILE_UPDATED_SUCCESS;
    setToast(true, `${fileName} ${message}`, TOAST_TYPE.SUCCESS);
    setReFetch(!reFetch);
  };

  const disableBackButton = () => {
    window.history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      window.history.pushState(null, null, document.URL);
    });
  };

  const updateParentRecords = (content, isChecked, rowsInfo) => {
    const { rowData } = rowsInfo;
    const checkedSites = content?.map((record) => {
      if (record?.lineItemId === rowData?.lineItemId) {
        return { ...record, checkBox: { ...record?.checkbox, isChecked } };
      }
      return { ...record };
    });
    setLineItems((records) => ({ ...records, content: checkedSites }));
  };

  const getEmailMessage = () => {
    if (isNLD_OR_LL()) {
      return `Pricing proposal of all the ${Math.floor(
        ((lineItems.feasibilityStatusMap && lineItems.feasibilityStatusMap.FEASIBLE) || lineItems.totalElement) / 2
      )} links will be shared to provided email ID - ${customerDetail && customerDetail.customerEmail ? customerDetail.customerEmail : ''}.`;
    }
    return `Pricing proposal of all the ${
      (lineItems.feasibilityStatusMap && lineItems.feasibilityStatusMap.FEASIBLE) || lineItems.totalElement
    } sites will be shared to provided email ID - ${customerDetail && customerDetail.customerEmail ? customerDetail.customerEmail : ''}.`;
  };

  useEffect(() => {
    if (isSameMedia && !isUserTypeIsKAM()) {
      setTableHeaders(HEADERS);
    } else if (blockJourney || isUserTypeIsKAM()) {
      const filterHeaders = HEADERS.filter(({ cellType }) => CELLTYPE_ENUM.CHECKBOX !== cellType);
      setTableHeaders(filterHeaders);
    } else {
      setTableHeaders(HEADERS);
    }
  }, [blockJourney]);

  useEffect(() => {
    disableBackButton();
    scrollToTop();
    showSteps(true);
    setActiveStep(3);

    if (!isBulkUpgrade()) {
      fetchCommercialAttributes();
    }
  }, []);

  useEffect(() => {
    if (isBulkUpgrade()) {
      setTableHeaders(HEADERS);
      callFetchLineItems();
    }
  }, [isBulkUpgrade()]);

  const checkIsSameMedia = (sameMedia) => {
    if (sameMedia) {
      setIsSameMedia(true);
    } else {
      setIsSameMedia(false);
    }
  };

  return (
    <React.Fragment>
      <section className="multi_site_section plan-page">
        {infoContent?.length > 0 && (
          <div className="info_content">
            <div className="icon">
              <img src={ribbonBadge} alt="" />
            </div>
            <p> {infoContent}</p>
          </div>
        )}
        <div className="multi_site_card">
          <div className="pnq_table table_card">
            {
              <React.Fragment>
                <CustomTable
                  loader={<TableLoader style />}
                  showLoader={isLoading && !showEmailPopUp} /* {true} */
                  renderHeaderSection={renderHeaderSection}
                  headers={tableHeaders}
                  contents={lineItems?.content}
                  onCellClickHandler={onCellClickHandler}
                  totalPages={lineItems.totalPages}
                  totalRecords={lineItems.totalElement}
                  onChange={onTableStateChange}
                  searchTypeDefault={SEARCH_OPTIONS[0]}
                  showSearch={true}
                  multipleSort={IS_MULTIPLE_SORT}
                  renderMessage={renderMessage(message)}
                  updateParentRecords={updateParentRecords}
                  renderSelectAll={renderSelectAll}
                  CustomSearchFilter={CustomSearchFilter}
                  paginationLength={paginationLength}
                  isRowSpanAllow={(isNLD_OR_LL() || isVPN_OR_DI()) && !isBulkUpgrade()}
                  mergeKey={'lineItemId'}
                ></CustomTable>
              </React.Fragment>
            }
          </div>
        </div>
        {isUserTypeIsKAM() && (
          <KamView
            displayOneTime={displayOneTime}
            feasibleSite={lineItems && lineItems.totalElement}
            setInfoContent={setInfoContent}
            setToast={setToast}
            showCancelPopUp={setShowCancelPopup}
            SetBlockJourney={SetBlockJourney}
            reFetch={reFetch}
            lineItems={lineItems}
          ></KamView>
        )}
      </section>
      {showEmailPopUp && (
        <EmailPricingProposal
          defaultEmail={customerDetail?.customerEmail}
          title="Email Pricing Proposal"
          content="Please provide the email address to send the Pricing Proposal"
          onSubmit={onEmailPricingSubmit}
          onCancel={closeEmail}
          isLoading={isLoading}
        ></EmailPricingProposal>
      )}

      {showLocationModal && (
        <LocationModal showLocationModal={showLocationModal} setShowLocationModal={setShowLocationModal} rowData={convertToLocationData(selectedRowData)}></LocationModal>
      )}

      <CircuitDetail circuitModalDataSet={circuitModalDataSet} isOpen={showCircuitDetailModal} onClose={setShowCircuitDetailModal} />

      {showNeedAssistancePopUp && (
        <NeedAssistantPopup
          customerDetail={customerDetail}
          closeNeedAssistantPopup={setNeedAssistancePopUp}
          setRemarksValue={setRemarksValue}
          remarksValue={remarksValue}
          submitAddDiConnectionDetails={onSaveNeedAssitance}
          btnDisabled={false}
        />
      )}
      {showAvailableConfig && (
        <ViewAvailableConfiguration
          partyId={partyId}
          commercialAttribute={commercialAttribute}
          open={showAvailableConfig}
          setOpen={setShowAvailableConfig}
        ></ViewAvailableConfiguration>
      )}

      {showFileUpload && (
        <ConfigureSiteWithExcel setToast={setToast} isOpen={showFileUpload} setIsOpen={setShowFileUpload} uploadCallBack={onExcelFileUploaded}></ConfigureSiteWithExcel>
      )}

      {!isUserTypeIsKAM() && (
        <Footer
          setCustomerDetail={setCustomerDetail}
          partyId={partyId}
          setMessage={setMessage}
          setToast={setToast}
          history={history}
          showCancelPopUp={setShowCancelCart}
          reFetch={reFetch}
          lineItems={lineItems}
          blockJourney={blockJourney}
          SetBlockJourney={SetBlockJourney}
          onCancel={setShowCancelPopup}
          tellParentIfSameMedia={checkIsSameMedia}
          customerDetail={customerDetail}
        ></Footer>
      )}

      {(showCancelPopup || showCancelCart) && (
        <CancelOrderPopup
          isdedicatedJourney={isdedicatedJourney}
          setToast={setToast}
          isMultiSite={false}
          showCancelCart={showCancelCart}
          setshowPopup={showCancelCart ? setShowCancelCart : setShowCancelPopup}
          isSummaryPage={false}
          isCustomerCancel={!isUserTypeIsKAM()}
          metaData={lineItems}
          isUpgrade={isBulkUpgrade()}
        ></CancelOrderPopup>
      )}
    </React.Fragment>
  );
};

export default ConfigurePlanPricing;
